import React, { useState, useEffect } from "react";
import Adminsidebar from "../components/Adminsidebar";
import Adminheader from "../components/Adminheader";
import Uppercase from "../components/Uppercase";
import { format } from "date-fns";
import { FaEdit, FaTrashAlt, FaPlus } from "react-icons/fa";
import axios from "axios";
import "./Admininvoice.css";
import { useYearContext } from "../components/YearContext";
import {toast} from "react-toastify";

function Admininvoice() {
  const [openSidebarToggle, setOpenSidebarToggle] = useState(false);
  const openSidebar = () => {
    setOpenSidebarToggle(!openSidebarToggle);
  };

  const { yearSelected } = useYearContext();

  const [showAddInvoice, setShowAddInvoice] = useState(false);

  const [searchInput, setSearchInput] = useState(""); // Store search input
  const [clientDetails, setClientDetails] = useState([]); // Store client details
  const [clientEmail, setClientEmail] = useState("");
  const [invoiceData, setInvoiceData] = useState({
    userName: "",
    phoneNumber: "",
    email: "",
    invoiceDate: "",
    services: "",
    ssn: "",
    callerName: "",
    price: "",
    discount: "",
    referral: "",
    totalAmount: "",
    totalBill: "",
    paymentStatus: "Pending",
  });

  const [invoices, setInvoices] = useState([]);
  const [services, setServices] = useState([]);
  const [service, setService] = useState("");
  const [state, setState] = useState("");
  const [totalAmount, setTotalAmount] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [referralBonus, setReferralBonus] = useState(0);
  const [totalBill, setTotalBill] = useState(0);
  const [isPreview, setIsPreview] = useState(false);

  // New inputs
  const [invoiceDate, setInvoiceDate] = useState(new Date()); // Initialize with current date
  const [clientName, setClientName] = useState("");
  const [phoneNumber, setphoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [callerName, setCallerName] = useState("");
  const [ssn, setSSN] = useState("");

  const validStateCodes = [
    "AL",
    "AK",
    "AZ",
    "AR",
    "CA",
    "CO",
    "CT",
    "DE",
    "FL",
    "GA",
    "HI",
    "ID",
    "IL",
    "IN",
    "IA",
    "KS",
    "KY",
    "LA",
    "ME",
    "MD",
    "MA",
    "MI",
    "MN",
    "MS",
    "MO",
    "MT",
    "NE",
    "NV",
    "NH",
    "NJ",
    "NM",
    "NY",
    "NC",
    "ND",
    "OH",
    "OK",
    "OR",
    "PA",
    "RI",
    "SC",
    "SD",
    "TN",
    "TX",
    "UT",
    "VT",
    "VA",
    "WA",
    "WV",
    "WI",
    "WY",
  ];

  const validateSSN = (ssn) => {
    const ssnRegex = /^[1-8]\d{8}$/;
    return ssnRegex.test(ssn);
  };

  const validateMobileNumber = (number) => {
    const mobileRegex = /^\d{10}$/;
    return mobileRegex.test(number);
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const addService = () => {
    const { services: selectedService, price } = invoiceData;
    // Get service and price from invoiceData

    if (!selectedService || !price || price <= 0) {
      toast.error("Please provide valid service and price greater than 0.");
      return;
    }

    if (
      selectedService === "State Return" &&
      (!state || !validStateCodes.includes(state))
    ) {
      toast.error("Please enter a valid state code in capitals (e.g., CA, NY).");
      return;
    }

    const newService = {
      service: selectedService,
      price: parseInt(price, 10),
      state: state || "",
    };

    // Update services list and total amount
    setServices([...services, newService]); // services is the state that holds the list of services
    setTotalAmount(totalAmount + newService.price);

    // Clear input fields after adding
    setInvoiceData({
      ...invoiceData,
      services: "", // Reset the service in invoiceData
      price: "", // Reset the price in invoiceData
    });
    setState(""); // Reset the state field if needed
  };
  const deleteService = (index) => {
    const removedService = services[index];
    setTotalAmount(totalAmount - removedService.price);
    setServices(services.filter((_, i) => i !== index));
  };

  useEffect(() => {
    // Parse values as numbers, defaulting to 0 if not valid
    const parsedDiscount = parseFloat(discount) || 0;
    const parsedReferralBonus = parseFloat(referralBonus) || 0;

    // Validate parsed values
    const validDiscount = Math.max(parsedDiscount, 0); // Ensure discount is not negative
    const validReferralBonus = Math.max(parsedReferralBonus, 0); // Ensure referral bonus is not negative

    // Calculate total bill: totalAmount - (discount + referral bonus)
    const calculatedTotalBill =
      totalAmount - (validDiscount + validReferralBonus);
    setTotalBill(calculatedTotalBill);
  }, [totalAmount, discount, referralBonus]);

  const handlePreview = () => {
    const { userName, phoneNumber, email, ssn } = invoiceData; // Destructure needed fields from invoiceData

    if (!invoiceData.userName || !invoiceData.phoneNumber) {
      toast.error("Please fill in all the required fields before previewing.");
      return;
    }
    if (!invoiceDate || !userName || !phoneNumber || !email) {
      toast.error("Please fill in all required fields.");
      return;
    }

    // if (!validateMobileNumber(phoneNumber)) {
    //   toast.error("Please enter a valid 10-digit mobile number.");
    //   return;
    // }

    if (!validateEmail(email)) {
      toast.error("Please enter a valid email address.");
      return;
    }

    if (ssn && !validateSSN(ssn)) {
      toast.error("Please enter a valid SSN (9 digits, not starting with 9).");
      return;
    }

    setIsPreview(true); // If everything is valid, set the preview state
  };

  // Function to fetch client details based on search input
  const handleSearch = async () => {
    try {
      // Sending a POST request with the search input to the backend
      const response = await axios.post(
        "https://api.easytaxexperts.com/get/searchingclientdetails", // Backend endpoint
        { searchClient: searchInput } // Sending the search input to the backend
      );

      // Checking if the response from the backend is successful
      if (response.data.success) {
        // If client is found, set the client details in the state
        const clientData = response.data.result[0];
        console.log(response.data.result);
        setInvoiceData({
          userName: clientData.client_name,
          phoneNumber: clientData.contact,
          email: clientData.email,
          invoiceDate: "", // You can set a default value for invoice date
          services: "", // Empty initially
          price: "", // Empty initially
          ssn: "", // Empty initially
          callerName: "", // Empty initially
        });
        setClientEmail(clientData.email); // Set the client email
        setClientDetails(response.data.result); // Store the client details in state
      } else {
        // If no client is found, reset the state and show an alert
        setClientDetails([]);
        toast.error("Client not found!");
      }
    } catch (err) {
      console.error("Error fetching client details:", err);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();



    if (!invoiceData.paymentStatus) {
      alert("Please select a Payment Status!");
      return;
    }

    
    try {
      // Merge the totalBill, discount, and referralBonus into invoiceData before submitting
      const finalInvoiceData = {
        ...invoiceData, // keep other invoice fields
        callerName: selectedCaller,
        discount: discount, // Assign discount from state
        referral: referralBonus, // Assign referral bonus from state
        totalBill: totalBill, // Assign calculated total bill from state
        invoiceDate: format(invoiceDate, "yyyy-MM-dd"), // Format the date correctly
        services,
  // Add paymentStatus here // Send the services array directly
      };

    

      // Send the final invoice data to backend
      await axios.post(
        "https://api.easytaxexperts.com/api/saveInvoice",
        finalInvoiceData
      );

      toast.success("Invoice saved successfully");

      // Reset form state after successful submission
      setInvoiceData({
        userName: "",
        phoneNumber: "",
        email: "",
        invoiceDate: "",
        services: [],
        ssn: "",
        callerName: "",
        discount: "",
        referral: "",
        totalBill: "",
        paymentStatus: "Pending", // Reset to default
      });
      setselectedCaller("");
    
      setTotalAmount(0);
      setDiscount(0);
      setReferralBonus(0);
      setServices([]);
      setShowAddInvoice(false);
    } catch (error) {
      console.error("Error saving invoice:", error);
      toast.error("Error saving invoice. Please try again.");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInvoiceData({
      ...invoiceData,
      [name]: value,
    });
  };

  // Handler for date change
  const handleDateChange = (date) => {
    setInvoiceDate(date);
  };

  const [employeeData, setEmployeeData] = useState([]);

  const fetchEmployeeData = async () => {
    try {
      const response = await axios.get(
        "https://api.easytaxexperts.com/api/getemployeedata"
      );
      setEmployeeData(response.data);
    } catch (error) {
      console.error("Error fetching employee data:", error);
    }
  };

  useEffect(() => {
    fetchEmployeeData();
  }, []);


  const [selectedCaller, setselectedCaller] = useState("");

  const handleItemClick = (username) => {
    setselectedCaller(username);
  };

  return (
    <div>
      <Uppercase />
      <div className="invoice-grid-container">
        <Adminheader openSidebar={openSidebar} />
        <Adminsidebar
          openSidebarToggle={openSidebarToggle}
          openSidebar={openSidebar}
        />
        <main className="main-container mt-2">
          <div className="container">
            <h4>Create Invoice</h4>
            <div className="d-flex gap-1">
              <input
                type="text"
                className="form-control w-50"
                placeholder="Enter email or phone number"
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
              />
              <button className="btn btn-primary" onClick={handleSearch}>
                Search
              </button>
            </div>

            <button
              className="btn btn-primary my-3"
              onClick={() => setShowAddInvoice(!showAddInvoice)}
            >
              <FaPlus /> Create Invoice
            </button>

            {showAddInvoice && clientDetails && (
              <div className=" mb-3">
                <h5>Add New Invoice</h5>

                <div className="invoice-form mt-3">
                  {/* Date and Client details section */}
                  <div className="">
                    <input
                      type="text"
                      name="userName"
                      className="form-control mb-2"
                      placeholder="User Name"
                      value={invoiceData.userName || clientDetails.client_name}
                      onChange={handleChange}
                      required
                    />
                    <input
                      type="text"
                      name="phoneNumber"
                      className="form-control mb-2"
                      placeholder="Phone Number"
                      value={invoiceData.phoneNumber || clientDetails.contact}
                      onChange={handleChange}
                      required
                    />
                    <input
                      type="email"
                      name="email"
                      className="form-control mb-2"
                      placeholder="Email"
                      value={invoiceData.email || clientDetails.email}
                      onChange={handleChange}
                      required
                    />
                    <input
                      type="date"
                      name="invoiceDate"
                      className="form-control mb-2"
                      placeholder="Invoice Date"
                      value={invoiceData.invoiceDate}
                      onChange={handleChange}
                      required
                    />

{/*                    
                    <div className="dropdown">
                      <input
                        className="form-control dropdown-toggle mb-2"
                        placeholder="Select Caller Name"
                        data-bs-toggle="dropdown"
                        name="callerName"
                        value={selectedCaller}
                        onChange={(e)=> setselectedCaller(e.target.value)}
                      />
                      <ul className="dropdown-menu employeeul">
                        {
                          employeeData
                          .filter((emp) => 
                            emp.username.toLowerCase().includes(selectedCaller.toLowerCase()))
                          .map((emp) => (
                            <li className="dropdown-item" key={emp.username} onClick = {() => handleItemClick(emp.username)}>{emp.username}</li>
                          ))
                        }
                      </ul>
                    </div> */}
                    <input
                      type="text"
                      name="ssn"
                      className="form-control mb-2"
                      placeholder="SSN"
                      value={invoiceData.ssn}
                      onChange={handleChange}
                      required
                    />


      </div>

                  {/* Service selection and display section */}
                  <div className="service-section mb-2">
                    <select
                      name="services"
                      className="form-select w-25"
                      value={invoiceData.services}
                      onChange={handleChange}
                    >
                      <option value="">Select Service</option>
                      <option value="Federal - 1040">Federal - 1040</option>
                      <option value="Federal - 1040 NR">Federal - 1040 NR</option>
                      <option value="State Return">State Return</option>
                      <option value="City Return">
                        City Return 
                      </option>
                      <option value="ITIN ">ITIN </option>
                      <option value="ITIN  - Non Resident">
                        ITIN  - Non Resident
                      </option>
                      <option value="Schedule C">
                        Schedule C
                      </option>
                      <option value="Schedule E">
                        Schedule E
                      </option>
                      <option value="FATCA">
                       FATCA 
                      </option>
                      <option value="FBAR">
                        FBAR
                      </option>
                     
                   
                   
                      <option value="Amended Return">
                        Amended Return
                      </option>
                      <option value="Optimized Tax Planning">
                        Optimized Tax Planning
                      </option>
                      <option value="Business Incorporation">
                       Business Incorporation
                      </option>
                      <option value="Partnership Return-1065">
                       Partnership Return-1065
                      </option>
                      <option value="S Corporation-1120 S">
                     S Corporation-1120 S
                      </option>
                      <option value="Corporation-1120">
                       Corporation-1120
                      </option>
                      <option value="Annual Report">
                       Annual Report
                      </option>
                      <option value="Franchise Tax">
                       Franchise Tax
                      </option>
                      <option value="Payroll Return 940">
                      Payroll Return 940
                      </option>
                      <option value="Payroll Return 941">
                       Payroll Return 941
                      </option>
                  
                      <option value="Extension Form 4868">
                       Extension Form 4868
                      </option>
                      <option value="Extension Form 7004">
                      Extension Form 7004
                      </option>
                    </select>

                    <input
                      type="text"
                      name="price"
                      className="form-control w-25"
                      placeholder="Price"
                      value={invoiceData.price}
                      onChange={handleChange}
                      required
                    />

                    {/* Show state dropdown if 'State Return' is selected */}
                    {invoiceData.services === "State Return" && (
                      <select
                        name="state"
                        className="form-select w-25"
                        value={state}
                        onChange={(e) => setState(e.target.value)}
                      >
                        <option value="">Select State</option>
                        {validStateCodes.map((code) => (
                          <option key={code} value={code}>
                            {code}
                          </option>
                        ))}
                      </select>
                    )}

                    <button onClick={addService}>Add Service</button>
                  </div>



                   {/* Payment Status selection */}
                   <select
    name="paymentStatus"
    className="form-select w-25 mb-2"
    value={invoiceData.paymentStatus || ''}
    onChange={handleChange}
  >
     <option value="">Select Payment Status</option>
    <option value="Pending">Pending</option>
    <option value="Paid">Paid</option>
  </select>
              

                  {services.length > 0 && (
                    <div className="service-list">
                      <h3>Services Added</h3>
                      <ul>
                        {services.map((s, index) => (
                          <li key={index}>
                            {s.service} - ${s.price} {s.state && `(${s.state})`}
                            <button onClick={() => deleteService(index)}>
                              Delete
                            </button>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}

                  {/* Calculation section */}
                  <div className="calculation-section mb-2">
                    <div className="d-flex gap-1">
                      <input
                        type="text"
                        name="discount"
                        className="form-control w-25"
                        placeholder="Discount"
                        value={discount}
                        onChange={(e) => setDiscount(e.target.value)} // Update discount
                      />
                      <input
                        type="text"
                        name="referral"
                        className="form-control w-25"
                        placeholder="Referral Bonus"
                        value={referralBonus}
                        onChange={(e) => setReferralBonus(e.target.value)} // Update referral bonus
                      />
                    </div>

                    <p>Total Amount: ${totalAmount}</p>
                    <p>Total Bill: ${totalBill}</p>
                  </div>

                  {/* Preview and Submit section */}
                  <div className="action-buttons">
                    <button onClick={handlePreview}>Preview</button>
                    {isPreview && (
                      <>
                        <button onClick={handleSubmit}>Submit</button>
                        <div className="invoice-preview">
                          <h3>Invoice Preview</h3>
                          <p>
                            <strong>Invoice Date:</strong>{" "}
                            {format(invoiceDate, "MM/dd/yyyy")}
                          </p>
                          <p>
                            <strong>Client Name:</strong>{" "}
                            {invoiceData.userName || "N/A"}
                          </p>
                          <p>
                            <strong>Mobile Number:</strong>{" "}
                            {invoiceData.phoneNumber || "N/A"}
                          </p>
                          <p>
                            <strong>Email:</strong> {invoiceData.email || "N/A"}
                          </p>
                          {/* <p>
                            <strong>Caller Name:</strong>{" "}
                            {selectedCaller || "N/A"}
                          </p> */}
                          <p>
                            <strong>SSN:</strong> {invoiceData.ssn || "N/A"}
                          </p>
                          <h4>Services:</h4>
                          <ul>
                            {services.map((s, index) => (
                              <li key={index}>
                                <strong>Service:</strong> {s.service} |
                                <strong> Price:</strong> ${s.price}
                                {s.state && ` | State: ${s.state}`}
                              </li>
                            ))}
                          </ul>
                          <p>
                            <strong>Total Amount:</strong> ${totalAmount}
                          </p>
                          <p>
                            <strong>Discount:</strong> ${discount || "0"}
                          </p>
                          <p>
                            <strong>Referral Bonus:</strong> $
                            {referralBonus || "0"}
                          </p>
                          <p>
                            <strong>Total Bill:</strong> ${totalBill}
                          </p>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            )}

            
          </div>
        </main>
      </div>
    </div>
  );
}

export default Admininvoice;
